<template>
  <div class="promotion">
    <div>合作推广设置</div>
    <el-row class="main">
      <el-col :span="6" v-for="(v,i) in list" :key="i">
        <div class="content">
          <div>
            购买时长：
            <span v-if="v.time_unit==1">{{v.time_value}}月</span>
            <span v-if="v.time_unit==2">{{v.time_value}}年</span>
          </div>
          <div>价格：{{v.basic_amount}}</div>
          <div>账号数量：1</div>
          <div>备注：{{v.discount_tips}}</div>
          <div>英文提示：{{v.discount_tips_en}}</div>
          <div>有效期：{{v.expiration_time}}</div>
          <el-button type="danger" @click="drop(v.id)">删除</el-button>
          <el-button type="primary" @click="showerweima(v)">查看推广码</el-button>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="推广二维码" :visible.sync="dialogVisible" width="400px">
      <div>推广二维码</div>
      <div id="qrcode" v-if="dialogVisible"></div>
      <el-button type="primary" @click="downloadQrcode()">下载图片</el-button>

      <div>推广链接</div>
      <el-input type="text" v-model="link" readonly />
      <el-button type="primary" @click="copy(link)">复制链接</el-button>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data: () => ({
    dialogVisible: false,
    list: [],
    link: "",
    userinfo: null
  }),
  components: { QRCode },
  methods: {
    getlist() {
      this.$axios.get("promote-price-configs").then(res => {
        if (res.code == 1) {
          this.$set(this, "list", res.data);
        }
      });
    },
    drop(id) {
      this.$confirm("此操作将永久删除该活动, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios.delete("promote-price-configs/" + id).then(res => {
            this.$message({
              message: res.message,
              type: "success"
            });
            if (res.code == 1) {
              this.getlist();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    showerweima(val) {
      this.link = `${process.env.VUE_APP_PROMOTE_URL}?id=${this.userinfo.id}&type=2&count=1&time_unit=${val.time_unit}&time_value=${val.time_value}&price_config_id=${val.id}&version_id=1`;
      this.dialogVisible = true;
      this.$nextTick(function() {
        this.qrcode();
      });
    },
    qrcode() {
      let that = this;
      let qrcode = new QRCode("qrcode", {
        width: 124,
        height: 124, // 高度
        text: that.link // 二维码内容
        // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f',   // 背景色
        // foreground: '#ff0'    // 前景色
      });
    },
    downloadQrcode() {
      // 获取base64的图片节点
      let img = document
        .getElementById("qrcode")
        .getElementsByTagName("img")[0];
      // 构建画布
      let canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      canvas.getContext("2d").drawImage(img, 0, 0);
      // 构造url
      let url = canvas.toDataURL("image/png");
      // 构造a标签并模拟点击
      let downloadLink = document.createElement("a");
      downloadLink.setAttribute("href", url);
      downloadLink.setAttribute("download", "二维码.png");
      downloadLink.click();
    },
    // 复制
    copy(text) {
      let aux = document.createElement("input");
      aux.setAttribute("value", text);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
      this.$message({
        message: "复制成功！",
        type: "success"
      });
    }
  },
  mounted() {
    this.getlist();
    this.$set(this, "userinfo", JSON.parse(sessionStorage.getItem("userinfo")));
  }
};
</script>

<style lang='scss' scoped>
.promotion {
  margin-top: 10px;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 4px;
  .main {
    .el-col-6 {
      padding: 5px;
      .content {
        text-align: center;
        padding: 4px;
        background: #bce2f4;
        border-radius: 4px;
        .avatar-uploader-icon {
          font-size: 40px;
          line-height: 1;
          color: #8c939d;
        }
      }
    }
  }
}
</style>